const React = require('react');

const UniversalContext = React.createContext(null);

module.exports = UniversalContext;
